/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SignupImport } from './routes/signup'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as RecoverPasswordImport } from './routes/recover-password'
import { Route as LoginImport } from './routes/login'
import { Route as LayoutImport } from './routes/_layout'
import { Route as LayoutIndexImport } from './routes/_layout/index'
import { Route as LayoutWritingsImport } from './routes/_layout/writings'
import { Route as LayoutToolsImport } from './routes/_layout/tools'
import { Route as LayoutTableListImport } from './routes/_layout/tableList'
import { Route as LayoutTableFieldsImport } from './routes/_layout/tableFields'
import { Route as LayoutSettingsImport } from './routes/_layout/settings'
import { Route as LayoutReportsImport } from './routes/_layout/reports'
import { Route as LayoutExtractionImport } from './routes/_layout/extraction'
import { Route as LayoutDocumentListImport } from './routes/_layout/documentList'
import { Route as LayoutConversationsImport } from './routes/_layout/conversations'
import { Route as LayoutChatListImport } from './routes/_layout/chatList'
import { Route as LayoutAiImport } from './routes/_layout/ai'
import { Route as LayoutAdminImport } from './routes/_layout/admin'
import { Route as LayoutWritingWritingIdImport } from './routes/_layout/writing/$writingId'
import { Route as LayoutTableTableIdImport } from './routes/_layout/table/$tableId'
import { Route as LayoutReportJobReportJobIdImport } from './routes/_layout/reportJob/$reportJobId'
import { Route as LayoutReportReportIdImport } from './routes/_layout/report/$reportId'
import { Route as LayoutChatConvIdImport } from './routes/_layout/chat/$convId'

// Create/Update Routes

const SignupRoute = SignupImport.update({
  path: '/signup',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordRoute = ResetPasswordImport.update({
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const RecoverPasswordRoute = RecoverPasswordImport.update({
  path: '/recover-password',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const LayoutIndexRoute = LayoutIndexImport.update({
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutWritingsRoute = LayoutWritingsImport.update({
  path: '/writings',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutToolsRoute = LayoutToolsImport.update({
  path: '/tools',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTableListRoute = LayoutTableListImport.update({
  path: '/tableList',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTableFieldsRoute = LayoutTableFieldsImport.update({
  path: '/tableFields',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSettingsRoute = LayoutSettingsImport.update({
  path: '/settings',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutReportsRoute = LayoutReportsImport.update({
  path: '/reports',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutExtractionRoute = LayoutExtractionImport.update({
  path: '/extraction',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDocumentListRoute = LayoutDocumentListImport.update({
  path: '/documentList',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutConversationsRoute = LayoutConversationsImport.update({
  path: '/conversations',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutChatListRoute = LayoutChatListImport.update({
  path: '/chatList',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAiRoute = LayoutAiImport.update({
  path: '/ai',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminRoute = LayoutAdminImport.update({
  path: '/admin',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutWritingWritingIdRoute = LayoutWritingWritingIdImport.update({
  path: '/writing/$writingId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTableTableIdRoute = LayoutTableTableIdImport.update({
  path: '/table/$tableId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutReportJobReportJobIdRoute = LayoutReportJobReportJobIdImport.update(
  {
    path: '/reportJob/$reportJobId',
    getParentRoute: () => LayoutRoute,
  } as any,
)

const LayoutReportReportIdRoute = LayoutReportReportIdImport.update({
  path: '/report/$reportId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutChatConvIdRoute = LayoutChatConvIdImport.update({
  path: '/chat/$convId',
  getParentRoute: () => LayoutRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/recover-password': {
      preLoaderRoute: typeof RecoverPasswordImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/signup': {
      preLoaderRoute: typeof SignupImport
      parentRoute: typeof rootRoute
    }
    '/_layout/admin': {
      preLoaderRoute: typeof LayoutAdminImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/ai': {
      preLoaderRoute: typeof LayoutAiImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/chatList': {
      preLoaderRoute: typeof LayoutChatListImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/conversations': {
      preLoaderRoute: typeof LayoutConversationsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/documentList': {
      preLoaderRoute: typeof LayoutDocumentListImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/extraction': {
      preLoaderRoute: typeof LayoutExtractionImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/reports': {
      preLoaderRoute: typeof LayoutReportsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings': {
      preLoaderRoute: typeof LayoutSettingsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tableFields': {
      preLoaderRoute: typeof LayoutTableFieldsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tableList': {
      preLoaderRoute: typeof LayoutTableListImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tools': {
      preLoaderRoute: typeof LayoutToolsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/writings': {
      preLoaderRoute: typeof LayoutWritingsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/': {
      preLoaderRoute: typeof LayoutIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/chat/$convId': {
      preLoaderRoute: typeof LayoutChatConvIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/report/$reportId': {
      preLoaderRoute: typeof LayoutReportReportIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/reportJob/$reportJobId': {
      preLoaderRoute: typeof LayoutReportJobReportJobIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/table/$tableId': {
      preLoaderRoute: typeof LayoutTableTableIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/writing/$writingId': {
      preLoaderRoute: typeof LayoutWritingWritingIdImport
      parentRoute: typeof LayoutImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  LayoutRoute.addChildren([
    LayoutAdminRoute,
    LayoutAiRoute,
    LayoutChatListRoute,
    LayoutConversationsRoute,
    LayoutDocumentListRoute,
    LayoutExtractionRoute,
    LayoutReportsRoute,
    LayoutSettingsRoute,
    LayoutTableFieldsRoute,
    LayoutTableListRoute,
    LayoutToolsRoute,
    LayoutWritingsRoute,
    LayoutIndexRoute,
    LayoutChatConvIdRoute,
    LayoutReportReportIdRoute,
    LayoutReportJobReportJobIdRoute,
    LayoutTableTableIdRoute,
    LayoutWritingWritingIdRoute,
  ]),
  LoginRoute,
  RecoverPasswordRoute,
  ResetPasswordRoute,
  SignupRoute,
])

/* prettier-ignore-end */
